import CardiomiopatieEdit from "./components/CardiomiopatieEdit.vue";
import CardiomiopatieView from "./components/CardiomiopatieView.vue";
import CardiomiopatieList from "./components/CardiomiopatieList.vue";

export default {
    CardiomiopatieEdit,
    CardiomiopatieView,
    CardiomiopatieList,
};
